export interface DumpsterSize {
  id: string
  yards: number
  name: string
  price: number
  weightLimit: string
  dimensions: string
  rentalDays: number
  bestFor: string
  examples: string[]
  popular?: boolean
}

export const RENTAL_DAYS = 7

export const DUMPSTERS: DumpsterSize[] = [
  {
    id: '10-yard',
    yards: 10,
    name: '10 Yard',
    price: 349,
    weightLimit: '2 tons',
    dimensions: "12' L × 8' W × 3.5' H",
    rentalDays: RENTAL_DAYS,
    bestFor: 'Small cleanouts & single rooms',
    examples: [
      'Garage or attic cleanout',
      'Small bathroom remodel',
      'Yard debris',
    ],
  },
  {
    id: '20-yard',
    yards: 20,
    name: '20 Yard',
    price: 449,
    weightLimit: '3 tons',
    dimensions: "22' L × 8' W × 4.5' H",
    rentalDays: RENTAL_DAYS,
    bestFor: 'Renovations & flooring projects',
    examples: [
      'Kitchen remodel',
      'Flooring & carpet removal',
      'Large cleanout',
    ],
    popular: true,
  },
  {
    id: '30-yard',
    yards: 30,
    name: '30 Yard',
    price: 549,
    weightLimit: '4 tons',
    dimensions: "22' L × 8' W × 6' H",
    rentalDays: RENTAL_DAYS,
    bestFor: 'Major renovations & new builds',
    examples: [
      'Whole-home renovation',
      'New construction',
      'Commercial cleanout',
    ],
  },
  {
    id: '40-yard',
    yards: 40,
    name: '40 Yard',
    price: 649,
    weightLimit: '5 tons',
    dimensions: "22' L × 8' W × 8' H",
    rentalDays: RENTAL_DAYS,
    bestFor: 'Large construction & demolition',
    examples: [
      'Commercial construction',
      'Demolition debris',
      'Large-scale cleanout',
    ],
  },
]

export function getDumpster(id: string | null): DumpsterSize | undefined {
  return DUMPSTERS.find((d) => d.id === id)
}

export function formatCurrency(amount: number): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
  }).format(amount)
}
